import React from "react";
import { withStyles, IconButton } from "@material-ui/core";
import { Refresh } from "@material-ui/icons";

const styles = (theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  retryLabel: {
    fontSize: 16,
    color: theme.iconColor,
  },
  retryText: {
    fontSize: theme.textFontSize,
    textDecorationLine: "underline",
    color: theme.warningTextColorDispatch,
    fontWeight: "bold",
    marginLeft: 4,
  },
});

const Retry = ({ classes, onClick }) => {
  return (
    <div className={classes.container}>
      <span className={classes.retryLabel}>Failed to load KPI</span>
      <IconButton
      onClick={onClick}
      >
        <Refresh className={classes.refreshIcon} />
        <span className={classes.retryText}>RETRY</span>
      </IconButton>
    </div>
  );
};

export default withStyles(styles)(Retry);
